import stylesConfig from '../../../theme/config';

const styles = {
  menuItem: {
    fontSize: stylesConfig.typography.navlink,
    padding: '5px',
  },
  navBar: {
    height: 60,
    zIndex: 1201,
    backgroundColor: stylesConfig.colors.white,
    borderBottom: `1px solid ${stylesConfig.colors.dividerGrey}`,
    position: 'absolute',
    top: 0,
    left: 0,
  },
  logoBox: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'flex-end'
  },
  searchBox: {
    // flexGrow: 1,
    // float: 'right',
  },
  pagesBox: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'row-reverse',
  },
  toolBar: {
    height: 60,
    borderBottom: 1,
    borderColor: stylesConfig.colors.dividerGrey,
    paddingLeft: 0,
    paddingRight: 0,
  },
  logo: {
    height: 60,
    // margin: 66,
  },
};

export default styles;
